/*
 * @Description: ⽤户参与及好感 – 重点竞品对⽐
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-21 11:02:15
 * @LastEditTime: 2019-03-21 15:57:00
 */

import moment from 'moment';

export default (data, query, typeName) => {
  const [..._data] = data.charts;
  const brandList = _data.pop();
  const xAxis = _data.pop().map(item => moment(item).format('MM.DD'));

  const seriesData = _data.map((item, index) => {
    return {
      name: brandList[index],
      type: 'line',
      data: item,
      label: {
        fontSize: 8,
        fontWeight: 400,
        normal: {
          show: xAxis.length <= 10,
          position: 'top'
        }
      }
    }
  });

  return {
    title: {
      text: `${query.brandNames}与主要竞品 ${typeName}曲线对比`,
      textStyle: {
        fontSize: 12,
        fontWeight: 600
      },
      // subtext: `时间窗口：${moment(query.startDate).format('YYYY.MM.DD') } - ${moment(query.statisDate).format('YYYY.MM.DD')}`,
      subtextStyle: {
        fontSize: 10
      },
      // x: '20',
      y: 5
    },
    color:['#ffd70d','#608f9f','#014d67','#56b5a0','#248e76'],
    legend: {
      show:false,
      data: brandList,
      align: 'left',
      bottom:0,
      orient: 'horizontal'
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      // formatter: '{b}<br />{a}: {c}'cd 
    },
    xAxis: {
      data: xAxis,
      type: 'category',
      silent: false,
      splitLine: {
        show: false
      },
      fontSize: 0,
      axisLabel: {
        // interval:0,
        // rotate: 15// query.angle || 30
      }
    },
    yAxis:{
      type: 'value',
      boundaryGap: [0.2, 0.2],
      fontSize: 8,
      axisLabel:{
        show:true,
        formatter:'{value}%'
      }
    },
    grid: {
      top: 40,
      bottom: 40
    },
    series: seriesData,
    animationEasing: 'elasticOut',
    animationDelayUpdate: function (idx) {
      return idx * 5;
    }
  };


};


// WEBPACK FOOTER //
// src/chart/competingGoodsLine.js